"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "gost_779_alt",
    description: "GOST 7.79-2000 (aka ISO 9:1995) transliteration schema",
    url: "https://dangry.ru/iuliia/gost-779/",
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "yo",
        ж: "zh",
        з: "z",
        и: "i",
        й: "j",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "x",
        ц: "cz",
        ч: "ch",
        ш: "sh",
        щ: "shh",
        ъ: "``",
        ы: "y`",
        ь: "`",
        э: "е`",
        ю: "yu",
        я: "ya",
    },
    prev_mapping: null,
    next_mapping: {
        це: "c",
        ци: "c",
        цй: "c",
        цы: "c",
    },
    ending_mapping: null,
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Yuliya, s``esh` eshhyo е`tix myagkix franczuzskix bulok iz Joshkar-Oly`, da vy`pej altajskogo chayu",
        ],
    ],
};
